import React from 'react';
import { isIOSApp } from '../../../services/utils';
import { Button } from '@mui/material';
import * as H from 'history';
import { LocationDescriptor } from 'history';
import { ExternalLink } from '@lialo/pwa-ui/lib/ExternalLink';
import { useHistory } from 'react-router-dom';

interface Props {
  to: H.LocationDescriptor;
  children: React.ReactNode;
  startIcon?: React.ReactNode;
}

export const NextButton = ({ to, startIcon, children }: Props) => {
  const isInIOSApp = isIOSApp();
  const history = useHistory();

  return isInIOSApp ? (
    <Button
      size={'small'}
      color={'secondary'}
      variant={'contained'}
      component={ExternalLink}
      startIcon={startIcon}
      href={locationDescriptorToPath(to)}
    >
      {children}
    </Button>
  ) : (
    <Button
      startIcon={startIcon}
      size={'small'}
      color={'secondary'}
      variant={'contained'}
      onClick={() => history.push(to)}
    >
      {children}
    </Button>
  );
};

const locationDescriptorToPath = (locationDescriptor: LocationDescriptor): H.Path => {
  if (typeof locationDescriptor === 'string') return locationDescriptor;
  return H.createPath(locationDescriptor);
};
